import { render } from "./index.vue?vue&type=template&id=ba4c3496&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=ba4c3496&scoped=true&lang=css"

import exportComponent from "D:\\WorkGit\\GctMoreOnlineMarking\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba4c3496"]])

export default __exports__